import SEO from '../../components/base/SEO';
import Header from './components/Header';
import Hero from './components/Hero';
import BasicSpecs from './components/BasicSpecs';
import Merits from './components/Merits';
import Demerits from './components/Demerits';
import Reviews from './components/Reviews';
import SuitableFor from './components/SuitableFor';
import PointGuide from './components/PointGuide';
import HowToApply from './components/HowToApply';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';

export default function RakutenCard() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "FinancialProduct",
    "name": "大手ECモール系カード",
    "description": "年会費永年無料で基本還元率1.0%。大手ECモールでの利用で最大3倍のポイント還元。ECモール経済圏でお得に使える人気No.1クレジットカード。",
    "brand": {
      "@type": "Brand",
      "name": "大手ECモール系カード"
    },
    "image": "https://public.readdy.ai/ai/img_res/4451b1a52ff4e774eba64fb2040c84e1.jpg",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "JPY",
      "availability": "https://schema.org/InStock"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.7",
      "reviewCount": "3",
      "bestRating": "5",
      "worstRating": "1"
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="大手ECモール系カード詳細｜年会費無料・1%高還元｜クレカ比較ナビ"
        description="大手ECモール系クレジットカードの詳細情報。年会費永年無料で基本還元率1.0%、ECモールでの利用でさらにお得。スペック・メリット・デメリット・口コミを徹底解説します。"
        keywords="大手ECモール系カード,年会費無料,1%還元,ポイント,ネットショッピング,クレジットカード,おすすめ"
        canonical="/rakuten"
        structuredData={structuredData}
      />
      <Header />
      <Breadcrumb items={[
        { label: 'ホーム', path: '/' },
        { label: 'カード詳細', path: '/ranking' },
        { label: '大手ECモール系カード' }
      ]} />
      <Hero />
      <CTASection />
      <BasicSpecs />
      <Merits />
      <PointGuide />
      <Demerits />
      <CTASection />
      <Reviews />
      <SuitableFor />
      <HowToApply />
      <CTASection />
      <Footer />
    </div>
  );
}
